import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Spinner, Container } from 'react-bootstrap';

// مكون LoadingSpinner المضمن
const LoadingSpinner: React.FC = () => {
  return (
    <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
      <div className="text-center">
        <Spinner animation="border" variant="primary" style={{ width: '3rem', height: '3rem' }} />
        <p className="mt-3">جاري التحميل...</p>
      </div>
    </Container>
  );
};

interface PrivateRouteProps {
  allowedRoles?: string[];
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ allowedRoles }) => {
  const { currentUser, userData, loading } = useAuth();
  const location = useLocation();

  // إذا كان التحميل جاريًا، عرض مؤشر التحميل
  if (loading) {
    return <LoadingSpinner />;
  }

  // إذا لم يكن المستخدم مسجل الدخول، توجيهه إلى صفحة تسجيل الدخول
  if (!currentUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // إذا كان هناك أدوار محددة وليس لدى المستخدم الدور المطلوب
  if (allowedRoles && userData && !allowedRoles.includes(userData.role)) {
    // توجيه المستخدم إلى الصفحة المناسبة حسب دوره
    if (userData.role === 'admin') {
      return <Navigate to="/admin/dashboard" replace />;
    } else if (userData.role === 'teacher') {
      return <Navigate to="/teacher/dashboard" replace />;
    } else if (userData.role === 'student') {
      return <Navigate to="/student/dashboard" replace />;
    } else {
      // إذا لم يكن للمستخدم دور محدد، توجيهه إلى الصفحة الرئيسية
      return <Navigate to="/" replace />;
    }
  }

  // إذا كان المستخدم مسجل الدخول ولديه الصلاحيات المطلوبة، السماح بالوصول
  return <Outlet />;
};

export default PrivateRoute;
